import { createFileRoute } from "@tanstack/react-router";
import { SupplierDetailPageLayout } from "../../../pages/suppliers-page/supplier-detail-page-layout";

export const Route = createFileRoute("/_auth/_frame/suppliers/$supplierId")({
  component: SupplierDetailPageLayout,
});
